const tipoPreguntasResultado = {
    Booleano: { value: "TIP-P-001", color: "gray" },
    Numerico: { value: "TIP-P-003", color: "" },
    Texto: {value: "TIP-P-002", color: ""}
  };
  
export default tipoPreguntasResultado;